import { render, staticRenderFns } from "./CreatorBindingManagement.vue?vue&type=template&id=3f739e8c&scoped=true"
import script from "./CreatorBindingManagement.vue?vue&type=script&lang=js"
export * from "./CreatorBindingManagement.vue?vue&type=script&lang=js"
import style0 from "./CreatorBindingManagement.vue?vue&type=style&index=0&id=3f739e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f739e8c",
  null
  
)

export default component.exports